import React, { FC } from 'react';
import { useDispatch } from 'react-redux';
import { ICompany, IFile } from './interfaces';
import { BlacklistActions } from 'redux/actionCreators/blacklistActions';

interface ICompanyCard {
  props: ICompany;
  isAdmin: boolean;
  setCompanyToRemoveId: (state: number | null) => void;
}

const CompanyCard: FC<ICompanyCard> = ({ props, isAdmin, setCompanyToRemoveId }: ICompanyCard) => {
  const dispatch = useDispatch();

  const copyCompanyUrl = (cardItemId: number) => {
    navigator.clipboard.writeText(`${window.location.href}?id=${cardItemId}`);
  };

  const editCompanyHandler = (cardItemId: number) => {
    window.scrollTo(0, 300);
    dispatch(BlacklistActions.setCompanyToEdit(cardItemId));
  };

  const fileElements = props.files?.map((item: IFile, index: number) => {
    return (
      <a
        className="blacklist__company-card-file"
        key={`${item.id}_${index}`}
        href={item.download}
        title={item.filename}
        download
      >
        <img
          className="blacklist__company-card-file-icon"
          src={`/images/pages/Resources/Blacklist/card-item_icon-file-${index}.svg`}
          alt="file-icon"
        />
      </a>
    );
  });

  return (
    <div className="blacklist__company-card">
      <div className="blacklist__company-card-logo-box">
        <img className="blacklist__company-card-logo" src={props.logo} alt="company-logo" />
      </div>
      <div className="blacklist__company-card-info-box">
        <h5 className="blacklist__company-card-name">
          <div>
            <span className={`flag-icon flag-icon-${props.country_code?.toLowerCase()}`} />
            <span>{props.company_name}</span>
          </div>
          {isAdmin && (
            <div className="blacklist__company-card-actions">
              <img
                className="blacklist__company-card-actions-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-link.svg"
                alt="edit-icon"
                onClick={() => copyCompanyUrl(props.id)}
              />
              <img
                className="blacklist__company-card-actions-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-edit.svg"
                alt="edit-icon"
                onClick={() => editCompanyHandler(props.id)}
              />
              <img
                className="blacklist__company-card-actions-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-remove.svg"
                alt="remove-icon"
                onClick={() => setCompanyToRemoveId(props.id)}
              />
            </div>
          )}
        </h5>
        <div className="blacklist__company-card-sections">
          <div className="blacklist__company-card-section">
            <div className="blacklist__company-card-line">
              <img
                className="blacklist__company-card-line-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-globe.svg"
                alt="website"
              />
              <span>{props.website}</span>
            </div>
            <div className="blacklist__company-card-line">
              <img
                className="blacklist__company-card-line-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-people.svg"
                alt="key-person"
              />
              <span>{props.key_person}</span>
            </div>
            <div className="blacklist__company-card-line">
              <img
                className="blacklist__company-card-line-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-email.svg"
                alt="email"
              />
              <span>{props.email}</span>
            </div>
            <div className="blacklist__company-card-line">
              <img
                className="blacklist__company-card-line-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-phone.svg"
                alt="phone"
              />
              <span>{props.phone}</span>
            </div>
          </div>
          <div className="blacklist__company-card-section">
            <div className="blacklist__company-card-line">
              <img
                className="blacklist__company-card-line-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-date.svg"
                alt="date"
              />
              <span>{props.date_of_incident}</span>
            </div>
            <div className="blacklist__company-card-line">
              <img
                className="blacklist__company-card-line-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-city.svg"
                alt="city"
              />
              <span>{props.city_name}</span>
            </div>
            <div className="blacklist__company-card-line">
              <img
                className="blacklist__company-card-line-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-reason.svg"
                alt="reason"
              />
              <span>{props.reason}</span>
            </div>
            <div className="blacklist__company-card-line">
              <img
                className="blacklist__company-card-line-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-manager.svg"
                alt="manager"
              />
              <span>{props.manager}</span>
            </div>
          </div>
          <div className="blacklist__company-card-section">
            <div className="blacklist__company-card-line">
              <img
                className="blacklist__company-card-line-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-description.svg"
                alt="description"
              />
              <textarea
                className="blacklist__company-card-line-description"
                value={props.description}
                readOnly
              ></textarea>
            </div>
            <div className="blacklist__company-card-line files">
              <img
                className="blacklist__company-card-line-icon"
                src="/images/pages/Resources/Blacklist/card-item_icon-file.svg"
                alt="file"
              />
              <ul className="blacklist__company-card-files-list">{fileElements}</ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyCard;
